import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BeneficioDireitaComponent } from './beneficio-direita.component';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';

@NgModule({
  declarations: [
    BeneficioDireitaComponent
  ],
  imports: [
    TranslateModule,
    CommonModule,
    RouterModule,
    LocalizeRouterModule
  ],
  exports: [
    BeneficioDireitaComponent
  ]
})

export class BeneficioDireitaModule { }
